import {
  INVALID_NATIONAL_ID,
  INVALID_PHONE_NUMBER,
  NATIONAL_ID_REGEX,
  PHONE_NUMBER_REGEX
} from '@/constants';
import { ECategory, ENotificationType } from '@/enums';
import { z } from 'zod';

export const searchSchema = z
  .object({
    category: z.nativeEnum(ECategory, {
      required_error: 'Please select a category.'
    }),
    nationalId: z.string().regex(NATIONAL_ID_REGEX, INVALID_NATIONAL_ID),
    phoneNumber: z.string().regex(PHONE_NUMBER_REGEX, INVALID_PHONE_NUMBER).or(z.literal('')),
    motherName: z
      .string({ required_error: `Please enter your mother's name.` })
      .min(3)
      .or(z.literal('')),
    type: z.nativeEnum(ENotificationType, {
      required_error: 'Please select a notification type.'
    }),
    email: z.string().email({ message: 'Invalid email address.' }).or(z.literal('')),
    phoneIntl: z.string().or(z.literal(''))
  })
  .superRefine((values, ctx) => {
    if (values.category === ECategory.LOCAL && !values.phoneNumber) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: 'Phone number is required.',
        path: ['phoneNumber']
      });
    }

    if (values.category === ECategory.DIASPORA && !values.motherName) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: 'Mother name is required.',
        path: ['motherName']
      });
    }

    if (values.type === ENotificationType.EMAIL && !values.email) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: 'Email address is required.',
        path: ['email']
      });
    }

    if (
      values.category === ECategory.DIASPORA &&
      values.type === ENotificationType.SMS &&
      !values.phoneIntl
    ) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: 'Phone number is required.',
        path: ['phoneIntl']
      });
    }
  });

export type SearchFormValues = z.infer<typeof searchSchema>;
